import { UnsavedImDfm3dSlideStateType, UnsavedSlideStateType } from './reducer'

const defaultUnsavedSlides: UnsavedImDfm3dSlideStateType[] = []

export const getUnsavedImDfm3dSlides = (
    state: UnsavedSlideStateType,
    qmrId: string,
) =>
    state.unsavedImDfm3dSlides[qmrId as unknown as number] ||
    defaultUnsavedSlides

export const getUnsavedSlideTopic = (
    state: UnsavedSlideStateType,
    qmrId: string,
    slideId?: string,
) => {
    const selectedSlideInfo = state?.unsavedImDfm3dSlides[
        qmrId as unknown as number
    ]?.find((slide: { slideId: string }) => slide?.slideId === slideId)

    return selectedSlideInfo?.topic
}

export const getSlideToBeDuplicated = (
    state: UnsavedSlideStateType,
    qmrId: string,
    idx: string,
) => {
    const selectedSlideInfo = state?.unsavedImDfm3dSlides[
        qmrId as unknown as number
    ]?.find((slide: UnsavedImDfm3dSlideStateType) => slide?.slideId === idx)

    return selectedSlideInfo
}
